import React from 'react';
import ImagemHiperCard from 'assets/img/icones/icon-hipercard.png';

const LogoHiperCard = props => {
  return (<img src={ImagemHiperCard} width="100" heigth="56" alt="HiperCard" />)
};
export default LogoHiperCard;